import * as React from "react"
import Svg, { Path } from "react-native-svg"

const EyeSlashIcon = (props) => (
    <Svg
        width={20}
        height={20}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <Path
            d="M16.283 13.631c.233.234.61.245.848.016a17.659 17.659 0 0 0 2.588-3.18.87.87 0 0 0 .001-.934c-.977-1.547-4.464-6.408-9.72-6.408-.883.003-1.76.14-2.599.403-.435.136-.54.68-.218 1.003a.684.684 0 0 0 .684.162A7.43 7.43 0 0 1 10 4.375c2.65 0 4.849 1.46 6.46 3.071.673.677 1.286 1.411 1.831 2.194a.63.63 0 0 1 0 .72 16.486 16.486 0 0 1-1.99 2.35.648.648 0 0 0-.018.921Z"
            fill="#fff"
        />
        <Path
            d="M14.121 11.47A4.376 4.376 0 0 0 8.53 5.877l1.028 1.03a3.125 3.125 0 0 1 3.537 3.536l1.027 1.027Zm-3.678 1.624 1.027 1.027A4.376 4.376 0 0 1 5.877 8.53l1.03 1.028a3.125 3.125 0 0 0 3.536 3.537Z"
            fill="#fff"
        />
        <Path
            d="M4.188 6.838c-.225.2-.442.402-.648.608A16.418 16.418 0 0 0 1.709 9.64a.636.636 0 0 0 0 .72c.418.6 1.037 1.4 1.831 2.194 1.611 1.611 3.811 3.071 6.46 3.071.748 0 1.46-.116 2.133-.32a.683.683 0 0 1 .683.162c.323.324.218.87-.218 1.006-.84.263-1.715.4-2.598.402-5.256 0-8.744-4.861-9.72-6.408a.869.869 0 0 1 0-.934 17.596 17.596 0 0 1 2.575-3.166.624.624 0 0 1 .876.016l.454.455h.003ZM17.5 17.5a.626.626 0 0 1-.885 0L2.5 3.385a.626.626 0 1 1 .885-.885L17.5 16.615a.626.626 0 0 1 0 .885Z"
            fill="#fff"
        />
    </Svg>
)

export default EyeSlashIcon
